import moment from "moment-timezone";
import { Moment } from "moment-timezone";
import { classNames } from "../../helpers";

export default function ScheduleCalendarVerticalGrid({
  selectedDate,
  highlightSelectedDate,
}: {
  selectedDate: Moment;
  highlightSelectedDate?: boolean;
}) {
  const startOfTheWeek = moment(selectedDate).day(0);
  // The following will generate the 7 days of the week that the viewing date falls in.
  const dates = [...Array(7)].map((_, i) =>
    startOfTheWeek.clone().add(i, "day")
  );
  return (
    <div className="col-start-1 col-end-2 row-start-1 hidden grid-cols-7 grid-rows-1 divide-x divide-gray-100 sm:grid sm:grid-cols-7">
      <div className="col-start-1 row-span-full" />
      {dates.map((date, dayIndex) => (
        <div
          key={`Day-${dayIndex}`}
          className={classNames(
            `row-span-full`,
            date.day() === selectedDate.day() &&
              highlightSelectedDate &&
              "bg-brandblue-100 opacity-40"
          )}
          style={{
            gridColumnStart: date.day() + 1,
          }}
        />
      ))}
      <div className="col-start-8 row-span-full w-8" />
    </div>
  );
}
